import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded transition-all duration-300 font-serif tracking-wider uppercase focus:outline-none focus:ring-2 focus:ring-mystic-500 focus:ring-offset-2 focus:ring-offset-abyss';
  const variants = {
    primary: 'bg-mystic-600 text-white hover:bg-mystic-500 hover:shadow-[0_0_20px_rgba(124,58,237,0.4)] border border-transparent',
    secondary: 'bg-transparent border border-mystic-600 text-mystic-400 hover:bg-mystic-900/20 hover:text-white hover:border-mystic-400',
    ghost: 'bg-transparent text-gray-400 hover:text-white hover:bg-white/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={clsx(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-154">
      {children}
    </motion.button>;
}